import React from "react"
import { Switch, Route } from "react-router-dom"
import {
  Home,
  Merchandise,
  AboutUs,
  Campaign,
  NewsDetail,
  NotFound,
} from "../pages"

function RouterView() {
  return (
    <>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/merchandise" component={Merchandise} />
        <Route path="/aboutus" component={AboutUs} />
        <Route path="/campaign" component={Campaign} />
        <Route path="/read/:id" component={NewsDetail} />
        <Route path="*" component={NotFound} />
      </Switch>
    </>
  )
}

export default RouterView
